import { Component, Input } from '@angular/core'

@Component({
  selector: '[app-labeled-property]',
  styles: `
    :host {
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 100%;
        align-items: baseline;

        & > span {
            font-weight: 500;
            &.disabled  {
              opacity: 0.5;
            }
        }
    }
  `,
  template: `<span [class.disabled]="disabled">{{ label }}</span>
    <div><ng-content></ng-content></div>`,
})
export class LabeledPropertyComponent {
  @Input({ required: true })
  label: string
  @Input()
  disabled = false
}
